
import { defineStore } from 'pinia';

export const useSessionStore = defineStore('session', {
  state: () => ({
    sessionId: '',
    termId: '',
    sectionId: '',
  }),
  actions: {
    setSessionId(id: string) {
      this.sessionId = id;
    },
    setTermId(id: string) {
      this.termId = id;
    },
    setSectionId(id: string) {
      this.sectionId = id;
    },
  },
});
